<template>
  <div class="header">
    <img @click="changePage(0)" class="logo-img" src="../assets/logo.png">
    <ul class="nav-list" @mouseleave="recoverNav()">
      <li @click="changePage(index)" @mouseover="changeNav(index)" :class="activeIndex==index?'nav-item active':'nav-item'" v-for="(item,index) in navList" :key="index">{{item.title}}</li>
      <li class="active-line" :style="{left:(80*activeIndex+4)+'px'}"></li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "Header",
    data() {
      return {
        currentIndex:this.pageIndex,
        activeIndex:0,
        navList: [{
          name: 'Home',
          title: '首页'
        }, {
          name: 'AboutUs',
          title: '关于我们'
        }, {
          name: 'Service',
          title: '企业服务'
        }, {
          name: 'Production',
          title: '产品中心'
        }, {
          name: 'JoinUs',
          title: '加入我们'
        }]
      }
    },
    created(){
      this.currentIndex=this.pageIndex
      this.activeIndex=this.pageIndex
    },
    props:{
      pageIndex:{
        type:Number
      }
    },
    methods:{
      changeNav(index){
        this.activeIndex=index
      },
      recoverNav(){
        setTimeout(()=>{
          this.activeIndex=this.currentIndex
        },100)
      },
      changePage(index){
        this.currentIndex=index;
        this.$router.push({name:this.navList[index].name})
      }
    }
  }
</script>

<style scoped>
  .header {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 1200px;
    height: 72px;
    display: flex;
    justify-content: space-between;
    z-index: 10;
  }

  .logo-img {
    height: 48px;
    margin-top: 14px;
    cursor: pointer;
  }
  .nav-list{
    display: flex;
    justify-content: space-between;
    width: 400px;
    position: relative;
    height: 72px;
  }
  .nav-item{
    width: 80px;
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
    cursor: pointer;
    opacity: 0.6;
    transition-duration: 0.6s;
    margin-top: 28px;
  }
  .nav-item.active{
    opacity: 1;
    transition-duration: 0.6s;
  }
  .active-line{
    width: 72px;
    height: 4px;
    background: #FCE504;
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    transition-duration: 0.6s;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue